import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { NgxEchartsModule } from 'ngx-echarts';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ApplyPipeModule, CalendarPickerModule , CustomSourceSelectorModule } from 'ngx-zcs-components';
import { MatNativeDateModule } from '@angular/material/core';
import * as echarts from 'echarts';
import { IonicModule } from '@ionic/angular';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';

import { DeviceDailyPowersComponent } from './device-daily-powers.component';
import { BlockTitleComponent } from '../components/block-title/block-title.component';

@NgModule({
  declarations: [
    DeviceDailyPowersComponent
  ],
  imports: [
    ApplyPipeModule,
    BlockTitleComponent,
    CalendarPickerModule,
    CommonModule,
    CustomSourceSelectorModule,
    IonicModule,
    MatButtonModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatIconModule,
    MatNativeDateModule,
    MatSelectModule,
    MatTooltipModule,
    NgxEchartsModule.forRoot({ echarts: () => import('echarts/core') })
  ],
  exports: [
    DeviceDailyPowersComponent,
  ],
})
export class DeviceDailyPowersModule { }
